import { format } from 'date-fns';

import type { Error } from '../types';
import { CPR_REGEX } from '../utils/regex';

export const validateCPR =
  (
    dob: Date | undefined,
    incorrectDateMessage?: Error['message'],
    incorrectFormatMessage?: Error['message']
  ) =>
  (value: string): Error => {
    const correctDate = dob && value?.substring(0, 6) === format(dob, 'ddMMyy');

    if (!value || !CPR_REGEX.test(value)) {
      return {
        valid: false,
        message: incorrectFormatMessage
      };
    } else if (!correctDate) {
      return {
        valid: false,
        message: incorrectDateMessage
      };
    } else {
      return { valid: true };
    }
  };
